<template>
  <vue-content-loading
    :width="300"
    :height="100">
    <rect
      x="255"
      y="0"
      rx="1"
      ry="1"
      width="15%"
      height="10%" />
    <rect
      x="0"
      y="13"
      rx="0"
      ry="0"
      width="100%"
      height="90%" />
  </vue-content-loading>
</template>

<script>
import VueContentLoading from 'vue-content-loading';

export default {
  name: 'JLoadingTable',
  components: {
    VueContentLoading,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/skeleton-loading/jLoadingTable.vue